import { SvgIcon } from '@mui/material';
import React from 'react';

const ActionOnCommandIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#FF7133" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0861 13.5H15.9139L15.6819 14.3908C15.4343 14.4793 15.2065 14.6068 15.0066 14.7656L14.0861 14.5129L13.5 15.4871L14.188 16.1256C14.1668 16.2474 14.1557 16.3725 14.1557 16.5C14.1557 16.6275 14.1668 16.7526 14.188 16.8744L13.5 17.5129L14.0861 18.4871L15.0066 18.2344C15.2065 18.3931 15.4343 18.5207 15.6819 18.6092L15.9139 19.5H17.0861L17.3181 18.6092C17.5657 18.5207 17.7935 18.3931 17.9934 18.2344L18.9139 18.4871L19.5 17.5129L18.812 16.8744C18.8332 16.7526 18.8443 16.6275 18.8443 16.5C18.8443 16.3725 18.8332 16.2474 18.812 16.1256L19.5 15.4871L18.9139 14.5129L17.9934 14.7656C17.7935 14.6068 17.5657 14.4793 17.3181 14.3908L17.0861 13.5ZM16.5 17.25C16.0684 17.25 15.7186 16.9142 15.7186 16.5C15.7186 16.0858 16.0684 15.75 16.5 15.75C16.9316 15.75 17.2814 16.0858 17.2814 16.5C17.2814 16.9142 16.9316 17.25 16.5 17.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.81299 18.5C6.43872 18.5 6.12646 18.3845 5.87622 18.1535C5.62598 17.9225 5.50049 17.634 5.5 17.288V7.71201C5.5 7.36649 5.62537 7.07825 5.87622 6.84726C6.12695 6.61624 6.43921 6.50049 6.81299 6.5H17.1879C17.5615 6.5 17.8738 6.61575 18.1246 6.84726C18.3754 7.07874 18.5005 7.367 18.5 7.71201V12.8221C17.8977 12.4589 17.192 12.25 16.4375 12.25C14.2284 12.25 12.4375 14.0409 12.4375 16.25C12.4375 17.0843 12.693 17.8589 13.1299 18.5H6.81299ZM10.1783 12.1873L12 11.3465L13.8217 12.1865C13.9679 12.254 14.1071 12.2498 14.2393 12.1737C14.3715 12.0977 14.4375 11.9878 14.4375 11.8438V7.25H9.5625V11.8438C9.5625 11.9872 9.62854 12.0973 9.76074 12.1737C9.89294 12.2498 10.0321 12.2542 10.1783 12.1873Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default ActionOnCommandIcon;
